import { Validators } from '@angular/forms';
import { GetCountriesData } from '@shared';
import { LatinLettersTooltip } from '../components/addresses/city-select-international/city-select.constants';
import { codeUKTZEDMoldovaPattern } from '../components/parcel-places/ii-code-uktzed/ii-code-uktzed.constants';
import { DefaultCountryPhoneConfig } from '../international-invoice.constants';

// Moldova
export const MD: Partial<GetCountriesData> = {
  ...DefaultCountryPhoneConfig,
  CityTooltip: LatinLettersTooltip,
  RecipientPostboxAvailable: true,
  RecipientSpotSelectionAvailable: true,
  RecipientPayerAllowed: false,
  RecipientPayerAllowedOverride: true,
  CodeUKTZED: {
    validators: [
      Validators.pattern(codeUKTZEDMoldovaPattern),
      Validators.required,
    ],
    resetFieldsWhenSwitchedToThisCountry: true,
    maxLength: 10,
  },
};
